module.exports = __webpack_public_path__ + "img/一键美颜--自定义调节.a244d343.png";